import React, { memo } from "react";
import Footer from "./Footer";
import Header from "./Header";

const WrapComponent = ({ children }) => {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
};

export default memo(WrapComponent);
